import axios from "axios";

export default {
  changePassword(params) {
    return axios.post("c-user/change-password", params);
  },
  resetPassword(email) {
    return axios.post("c-reset-password", { email });
  },
  reset({ token, email, password, password_confirmation }) {
    return axios.post("c-reset-password/reset", {
      token,
      email,
      password,
      password_confirmation,
    });
  },
};
